import cn from 'classnames';

//Types
import { ILinkedInBtn } from '~components/LinkedInAuthBtn/types';
//Icons
import LinkedinSmallLogoIcon from '~icons/LinkedinSmallLogoIcon';



export default function LinkedInBtn({title, className, disabled, onClick}: ILinkedInBtn) {
    return (
        <button type="button" className={cn('social-auth-btn', className)} disabled={disabled} onClick={onClick}>
            <div className="social-auth-btn__icon"><LinkedinSmallLogoIcon/></div>
            <div className="social-auth-btn__title">{title}</div>
        </button>
    );
}
